<template>
  <!-- Phase 1 Corrections - "Organ" changed to "Organ and Tissue" -->
  <Expandable header="Approved Organ and Tissue Transplant" class="h-100">
    <ul class="list-group list-group-flush pb-0">
      <li
        class="
          list-group-item
          d-flex
          justify-content-between
          align-items-center
        "
        v-for="(item, i) in list"
        :key="i"
      >
        <label class="mb-0 flex-grow-1 cursor-pointer" :for="'organs-' + i">{{
          item.name
        }}</label>

        <b-form-checkbox
          :id="'organs-' + i"
          class="cursor-pointer"
          v-model="model"
          @change="input"
          :disabled="isDisabled"
          :value="item.value"
        >
        </b-form-checkbox>
      </li>
    </ul>
  </Expandable>
</template>

<script>
import hospitalCreateMixins from "../../../assets/mixins/hospital.create.mixins";
import Expandable from "../../Expandable.vue";
export default {
  props: {
    value: Array,
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [hospitalCreateMixins],
  data() {
    return {
      model: [],
    };
  },
  components: { Expandable },
  computed: {
    master() {
      return this.$store.getters.master;
    },
    list() {
      if (this.master.master_organ instanceof Array == false) return [];
      let list = this.master.master_organ.filter(
        ({ license_available, allocation_available }) => {
          return allocation_available == 1 && license_available == 1;
        }
      );
      list = list.filter((item) => {
        return item.status != 4;
      });
      return list.map((item) => {
        return { value: item.organ_id, name: item.organ_name };
      });
    },
  },
  methods: {
    input() {
      this.$emit("input", this.model);
    },
  },
  mounted() {
    this.model = this.value;
  },
};
</script>

<style></style>
